<template>
  <div>
      <navbar/>
       <div class="container-fluid">
            <h3>Crear Cuenta</h3>
            <button @click="agregar">Add</button>
            <div class="row">
            <div class="col-md-6 ">
                Identificador: 
                <input class="form-control" v-model="form.identificador">
            </div>
            <div class="col-md-6 ">
                Razón social: 
                <input class="form-control" v-model="form.razonsocial">
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 ">
                Giro:
                <input class="form-control" v-model="form.giro">
            </div>
            <div class="col-md-6 ">
                Acuerdo:
                <select class="form-control" v-model="form.idsla">
                    <option v-for="item in allAcuerdos" :key="item.id" :value="item.id">{{item.nombre}}</option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 ">
                Representante:
                <select class="form-control" v-model="form.idrepresentante">
                    <option v-for="item in allContacto" :key="item.id" :value="item.id">{{item.nombre}}</option>
                </select>
            </div>
            <div class="col-md-6 ">
                Dirección:
                <input class="form-control" v-model="form.direccion">
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 ">
                Email:
                <input class="form-control" v-model="form.correo">
            </div>
            <div class="col-md-6 ">
                Teléfono:
                <input class="form-control" v-model="form.telefono">
            </div>
        </div>

        <h3>Redes Sociales</h3>
        <div class="row">
            <div class="col-md-6">
                Página:
                <input class="form-control" v-model="form.paginaweb">
            </div>
            <div class="col-md-6">
                Facebook:
                <input class="form-control" v-model="form.facebook">
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                Twitter:
                <input class="form-control" v-model="form.twitter">
            </div>
            <div class="col-md-6">
                Instagram:
                <input class="form-control" v-model="form.instagram">
            </div>
        </div>
            <pre>{{form}}</pre>
        </div>
  </div>
</template>

<script>
import { log } from 'util'
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
export default {
  components: {
        navbar: () => import('@/views/Agente/navBar.vue')
    },
    data(){
        return{
            form:{
                cf: {}
            }
        }
    },
    computed: {
        ...mapGetters('validatetoken', { 
            allAcuerdos: 'allAcuerdos',
            allContacto: 'allContacto'
        })
    },
      methods:{
        ...mapActions('validatetoken', {
            getAllAcuerdo: 'getAllAcuerdo',
            getContacto: 'getContacto',
            addCuenta: 'addCuenta'
        }),
        getAll(){
            Promise.all([
                this.getAllAcuerdo(),
                this.getContacto({
                    pagina: 1,
                    cantidad: 10
                })
                .then((data)=>{
                    this.$store.commit('validatetoken/setAllContacto', data)
                })
            ])
        },
        agregar(){
             this.addCuenta(this.form)
        },
   
    },
    created() {
        this.getAll()
    },
}
</script>

<style>

</style>